<div class="modal-header">
  <h5 class="modal-title">Save to Klyant</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">

  <!-- Klyant callback state -->
  <ng-container *ngIf="gettingCodeFromKlyant">
    <div *ngIf="isError" class="alert alert-danger">
      An error occurred contacting Klyant: <strong>{{errorMessage}}</strong>
    </div>
    <div *ngIf="!isError" class="alert alert-success">
      Logged into Klyant. Please
      <button type="button" class="btn btn-link p-0 align-baseline" (click)="closeWindow()">close</button>
      this window to continue.
    </div>
  </ng-container>

  <!-- Main state -->
  <ng-container *ngIf="!gettingCodeFromKlyant">

    <div class="mb-3">
        <label class="form-label fw-semibold">Select Existing Client</label>
        <ng-select
            [(ngModel)]="existingClientId"
            [items]="existingClients"
            bindValue="id"
            bindLabel="displayName"
            placeholder="Search clients..."
            [searchable]="true"
            [loading]="!isLoaded">
            <ng-template ng-label-tmp let-item="item">
                {{item.client_Code}} - {{item.first_Name}} {{item.last_Name}} ({{item.postal_Code}})
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
                {{item.client_Code}} - {{item.first_Name}} {{item.last_Name}} ({{item.postal_Code}})
            </ng-template>
        </ng-select>
    </div>

    <div *ngIf="isError" class="alert alert-danger">
      An error occurred contacting Klyant: <strong>{{errorMessage}}</strong>
    </div>

  </ng-container>

</div>

<div class="modal-footer" *ngIf="!gettingCodeFromKlyant">

  <button *ngIf="!addingToKlyant" type="button" class="btn btn-primary"
    [disabled]="!isLoaded" (click)="addClientAndMatter()">
    Add Matter and NEW Client
  </button>

  <button *ngIf="!addingToKlyant" type="button" class="btn btn-success"
    [disabled]="existingClientId == null || existingClientId == 0 || !isLoaded"
    (click)="updateClientAndMatter()">
    Add/Update Matter with EXISTING Client
  </button>

  <button *ngIf="addingToKlyant" type="button" class="btn btn-success" disabled>
    <span class="spinner-border spinner-border-sm" role="status"></span>
    Processing...
  </button>
</div>